/** Trust Score V2 tiers — mirrors server/features/vendor-sub-trust/utils/tier.js */
export type TrustTierName = 'platinum' | 'gold' | 'silver' | 'bronze' | 'review'

export interface TrustScoreData {
  id:                number | null
  computedScore:     number
  effectiveScore:    number
  overrideScore:     number | null
  isOverridden:      boolean
  tier:              TrustTierName
  tierLabel:         string
  isVisibleToVendor: boolean
  lastEventAt:       string | null
}

export const MAX_TRUST_SCORE = 763
